// import Honeybadger from 'honeybadger-js';
import { getATCButtonsAndIds } from './getATCButtonsAndIds';
import { startATCUpsell } from './startATCUpsell';
import { storeUpsellMap } from './storeUpsellMap';
import { upsellElements } from './upsellElements';

export const ATCUpsells = () => {
  let intervalCount = 0;

  const loadUpsell = setInterval(async () => {
    try {
      const {
        cartModal,
        cartWrapper,
        openUpsellArray,
        closeUpsellArray,
        upsellWrapper,
      } = upsellElements();
      intervalCount++;

      if (
        cartModal &&
        cartWrapper &&
        upsellWrapper &&
        openUpsellArray &&
        openUpsellArray[0] &&
        closeUpsellArray &&
        closeUpsellArray[0]
      ) {
        clearInterval(loadUpsell);
        const { hotATCButtons, productIds } = await getATCButtonsAndIds({
          upsellWrapper,
        });

        // fetch and save upsells
        await storeUpsellMap(productIds);

        const primeUpsell = (evt: MouseEvent): void => {
          const ATCButton = (evt.target as unknown) as HTMLElement;

          // Handles variant selectors
          const ATCForm = ATCButton.closest(
            '[data-node-type="commerce-add-to-cart-form"]'
          );

          const variantSelectors = (ATCForm?.querySelectorAll(
            '[data-node-type="commerce-add-to-cart-option-select"]'
          ) as unknown) as HTMLSelectElement[];

          if (variantSelectors && variantSelectors[0]) {
            let variantsSelected = true;
            variantSelectors?.forEach((option) => {
              if (option.value === '') {
                variantsSelected = false;
              }
            });

            if (!variantsSelected) {
              return;
            }
          }

          ATCButton?.removeEventListener('click', primeUpsell);

          const cartProductId = ATCForm?.getAttribute(
            'data-commerce-product-id'
          );

          if (cartProductId) {
            startATCUpsell(cartProductId);
          }
        };

        for (const button of hotATCButtons) {
          button.addEventListener('click', primeUpsell);
        }
      }

      if (intervalCount > 50) clearInterval(loadUpsell);
    } catch (error) {
      clearInterval(loadUpsell);
      throw error;
    }
  }, 50);
};
